module.exports = function() {
  return new Worker(__webpack_public_path__ + "bfbb924e10c06a57f32c.worker.js");
};